/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Expands a slider fill sprite to stretch between the end of a slider and the current handle position. */
@cc._decorator.ccclass
@cc._decorator.executeInEditMode
export default class SliderFill extends cc.Component
{
    /** The slider to fill. */
    @property({ type: cc.Slider, visible: true })
    private _slider: cc.Slider = null;

    /** @hidden */
    protected prevDiff: number = 0;

    /** @hidden */
    protected update(dt: number): void
    {
        let diff: number = this._slider.direction === cc.Slider.Direction.Horizontal ?
            this._slider.handle.node.position.x - this.node.position.x :
            this._slider.handle.node.position.y - this.node.position.y;

        if (diff !== this.prevDiff)
        {
            this.node.width = Math.abs(diff);
            this.prevDiff = diff;
        }
    }
}
